export default {
    menu_label: 'Network Intelligence',

    nav: {
        overview: 'Overview',
        constraints: 'Constraint Intelligence',
        delivery: 'Delivery Intelligence',
        supply_demand: 'Supply vs Demand',
        entitlement: 'Access & Entitlement',
        patient_friction: 'Patient Friction',
        provider_performance: 'Provider Performance',
    },

    filters: {
        time_range: 'Time Range',
        specialty: 'Specialty',
        payer: 'Payer',
        state: 'State',
        zip: 'ZIP',
        zip_placeholder: 'ZIP code',
        any: 'Any',
    },

    overview: {
        title: 'Network Intelligence Overview',
        subtitle: 'Real-time analytics and insights into your referral network',
        loading: 'Loading intelligence data…',
        error: 'Unable to load intelligence data. Please try again.',
        empty: 'No intelligence data for the selected period.',
    },

    constraints: {
        title: 'Constraint Intelligence',
        subtitle: 'Understand why referrals become constrained',
        loading: 'Loading constraint data…',
        error: 'Unable to load constraint data. Please try again.',
        empty: 'No constraint data for the selected period.',
        table: {
            reason_code: 'Reason Code',
            frequency: 'Frequency',
            percent: 'Share',
        },
    },

    delivery: {
        title: 'Delivery Intelligence',
        subtitle: 'Track outreach channel performance across the referral network',
        loading: 'Loading delivery data…',
        error: 'Unable to load delivery data. Please try again.',
        empty: 'No delivery data for the selected period.',
        kpis: {
            total_attempts: 'Delivery Attempts',
            success_rate: 'Attempt Success Rate',
            confirmation_rate: 'Confirmation Rate',
            total_confirmed: 'Deliveries Confirmed',
        },
        charts: {
            by_channel: 'Attempts by Channel',
            channel_table: 'Channel Performance',
        },
        table: {
            channel: 'Channel',
            attempts: 'Attempts',
            successes: 'Successes',
            failures: 'Failures',
            confirmed: 'Confirmed',
            success_rate: 'Success Rate',
        },
    },

    supply_demand: {
        title: 'Supply vs Demand',
        subtitle: 'Compare referral demand with available provider supply by specialty',
        loading: 'Loading supply and demand data…',
        error: 'Unable to load supply and demand data. Please try again.',
        empty: 'No supply or demand data for the selected period.',
        kpis: {
            demand: 'Referral Demand',
            supply: 'Provider Supply',
            specialties_with_demand: 'Specialties with Demand',
            zero_supply: 'Demand with Zero Supply',
        },
        charts: {
            by_specialty: 'Demand vs Supply by Specialty',
            gap_table: 'Specialty Gaps',
        },
        table: {
            specialty: 'Specialty',
            demand: 'Demand',
            supply: 'Supply',
            gap: 'Gap',
            constrained: 'Constrained',
            share: 'Demand Share',
        },
    },

    entitlement: {
        title: 'Access & Entitlement',
        subtitle: 'Track subscription blocks and practice entitlement across the network',
        loading: 'Loading entitlement data…',
        error: 'Unable to load entitlement data. Please try again.',
        empty: 'No entitlement data for the selected period.',
        kpis: {
            entitlement_blocks: 'Entitlement Blocks',
            trial: 'Trial Practices',
            premium: 'Premium Practices',
            network: 'Network Practices',
        },
        charts: {
            by_reason: 'Entitlement Block Reasons',
            subscriptions: 'Practice Subscriptions',
        },
        table: {
            reason_code: 'Reason Code',
            count: 'Count',
            percent: 'Share',
            subscription: 'Subscription',
            practices: 'Practices',
        },
    },

    patient_friction: {
        title: 'Patient Friction',
        subtitle: 'See where patients complete or stall on referral actions',
        loading: 'Loading patient friction data…',
        error: 'Unable to load patient friction data. Please try again.',
        empty: 'No patient action data for the selected period.',
        kpis: {
            total_actions: 'Patient Actions',
            unique_referrals: 'Referrals with Action',
            completion_rate: 'Action Completion Rate',
            hours_to_first: 'Avg Hours to First Action',
        },
        charts: {
            by_action: 'Actions by Type',
            action_table: 'Patient Action Breakdown',
        },
        table: {
            action: 'Action',
            count: 'Count',
            percent: 'Share',
        },
    },

    provider_performance: {
        title: 'Provider Performance',
        subtitle: 'Compare provider response volume, accept rates, and response time',
        loading: 'Loading provider performance…',
        error: 'Unable to load provider performance. Please try again.',
        empty: 'No provider response data for the selected period.',
        kpis: {
            providers: 'Providers Responding',
            responses: 'Total Responses',
            accept_rate: 'Accept Rate',
            avg_response: 'Avg Response Hours',
        },
        charts: {
            top_providers: 'Top Providers by Responses',
            provider_table: 'Provider Leaderboard',
        },
        table: {
            provider: 'Provider',
            npi: 'NPI',
            responses: 'Responses',
            accepted: 'Accepted',
            declined: 'Declined',
            proposed: 'Proposed Slots',
            accept_rate: 'Accept Rate',
            avg_hours: 'Avg Hours',
        },
    },

    kpis: {
        referral_completion_rate: 'Referral Completion Rate',
        matchable_rate: 'Matchable Rate',
        constrained_rate: 'Constrained Rate',
        unmatchable_rate: 'Unmatchable Rate',
        referrals_created: 'Referrals Created',
        average_time_to_schedule: 'Avg Time to Schedule',
        provider_response_time: 'Provider Response Time',
    },

    charts: {
        referral_funnel: 'Referral Funnel',
        constraint_breakdown: 'Constraint Breakdown',
        reason_ranking: 'Top Reason Codes',
        drop_off: 'Drop-off: {percent}%',
    },

    funnel: {
        created: 'Created',
        matchable: 'Matchable',
        delivered: 'Delivered',
        accepted: 'Accepted',
        scheduled: 'Scheduled',
        completed: 'Completed',
    },
}
